import * as React from "react"
import Svg, { Path } from "react-native-svg"

function VoltLogoNew(props) {
    return (
        <Svg
            width={75}
            height={64}
            viewBox="0 0 75 64"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M68.017 10.846C70.817 6.035 67.317 0 61.751 0l-24.5 42.323L25.924 23.11a14.433 14.433 0 00-12.434-7.104H9.16L37.092 64l30.925-53.154z"
                fill="#fff"
            />
            <Path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33.226 34.355L49.83 6.399A13.079 13.079 0 0161.076 0L37.249 41.18l-4.023-6.825zM36.332 63.998L8.398 16.008c-3.714 0-6.022 4.036-4.138 7.237L24.146 57.03a14.14 14.14 0 0012.186 6.968z"
                fill="#A1AEEA"
            />
        </Svg>
    )
}

export default VoltLogoNew
